import { type TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';

import type { AppDispatch, RootState } from '.';

const useAppDispatch = () => useDispatch<AppDispatch>();

const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { useAppDispatch, useAppSelector };
